const stringToHTML2 = (str) => {
  // If DOMParser is supported, use it
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, "text/html");
  return doc.body;
};

const loadCart = async () =>
  await $.ajax({
    cache: false,
    url: "/cart.json",
    type: "get",
    dataType: "json",
  });

const functionAnimation = (button) => {
  button.classList.add("animated");
  setTimeout(() => {
    button.classList.remove("animated");
  }, 300);
};

const renderShopifySection = async (sections) => {
  try {
    const { data: html } = await axios.get(`?sections=${sections}`);
    return html;
  } catch (error) {
    console.error(`Error: ${error.message}`);
  }
};

const addMinicartInformation = async () => {
  const sectionData = await renderShopifySection("header");
  const cartCount = document.querySelectorAll(".cart-count");

  document.querySelector("#CartContainerPopup").innerHTML = stringToHTML2(
    sectionData.header
  ).querySelector("#CartContainerPopup").innerHTML;

  cartCount.forEach((element) => {
    element.textContent = stringToHTML2(sectionData.header).querySelector(
      ".cart-count"
    ).textContent;
  });

  document.querySelector(".minicart-menu .no-items").classList.add("d-none");
  document
    .querySelector(".minicart-menu .content-form")
    .classList.remove("d-none");
};

const addPopUpInformation = async (data) => {
  const popUpContainer = document.querySelector(".cart-pop-up-main");

  popUpContainer.querySelector("#product-title").innerText = data.product_title;
  popUpContainer.querySelector(
    "#variant-color"
  ).innerText = `${data.options_with_values[0].name?.toLocaleLowerCase()}: ${data.options_with_values[0].value
    ?.split("_")[0]
    .toLocaleLowerCase()} | `;
  popUpContainer.querySelector(
    "#variant-size"
  ).innerText = `${data.options_with_values[1].name?.toLocaleLowerCase()}: ${data.options_with_values[1].value
  } | `;

  console.log(data);
  const precios = [
    data.discounted_price,
    data.final_line_price,
    data.price
  ].filter(precio => precio !== 0); 

  let precioMinimo;

  if (precios.length > 0) {
    precioMinimo = Math.min(...precios);
    console.log("El precio mínimo es:", precioMinimo);
  } 
  let showPrice_ = parseFloat(data.price);
  showPrice_     = showPrice_/100;
  popUpContainer.querySelector("#variant-price").innerText = `$${(showPrice_).toLocaleString("es-ES")}`;
  popUpContainer.querySelector("#cart_popup_img").src = data.featured_image.url;
  popUpContainer.querySelector("#cart_popup_img").alt = data.featured_image.alt;

  const newPrice = document.querySelector(
    `input[name="price-variant-${data.variant_id}"]`
  );

  if (newPrice != null) {
    popUpContainer.querySelector("#variant-price").textContent = `${(precioMinimo/100).toLocaleString("es-ES")}`;
  }

  popUpContainer.classList.add("open");
  document.body.style.overflow = "hidden";
  document.querySelector(".cart-overflow").classList.add("open");

  popUpContainer.querySelector(".close-popup").addEventListener("click", () => {
    document.body.style.overflow = "auto";
    popUpContainer.classList.remove("open");
    document.querySelector(".cart-overflow").classList.remove("open");
  });

  const sectionData = await renderShopifySection("product");

  popUpContainer.querySelector(".pop-up-button").innerHTML = stringToHTML2(
    sectionData.product
  ).querySelector(".pop-up-button").innerHTML;
};

const addToCartFunction = async (
  id,
  quantity,
  section = undefined,
  shippingMethod = null
) => {
  cart = await loadCart();
  shopifyProducts = cart?.items || [];

  let formData = {
    items: [
      {
        id: id,
        quantity: quantity,
      },
    ],
  };

  //Support bundled section rendering
  if (section) {
    formData.sections = section;
  }

  const existProductInCart = cart?.items.filter((e) => e.id === Number(id));

  if (existProductInCart.length > 0) {
    const data = {
      id: existProductInCart[0].key,
      quantity: existProductInCart[0].quantity + 1,
    };

    return await $.ajax({
      cache: false,
      url: "/cart/change.js",
      type: "post",
      dataType: "json",
      data,
    });
  } else {
    formData.items[0] = {
      ...shopifyProducts,
      ...formData.items[0],
      properties: {
        shippingMethod: {
          store_type: localStorage.getItem("selectedMethod"),
          ...((shippingMethod === "Tienda" || localStorage.getItem("selectedMethod") ==='Tienda') && {
          store: localStorage.getItem("stores"),
        }),
        },
      },
    };
  }

  try {
    const { data } = await axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      url: `/cart/add.js`,
      data: JSON.stringify(formData),
    });

    return data;
  } catch (error) {
    console.error(`Error: ${error.message}`);
  }
};

const sendDataForm = async (form) => {
  let id;
  const quantity = 1;
  let addCart = true;
  const shippingMethod = localStorage.getItem("selectedMethod") ?? null;

  for (const input of form) {
    if (input.name == "variant_id") {
      id = input.value;
    }

    if (input.type == "submit" && input.classList.contains("disabled")) {
      addCart = false;
    }
  }

  if (addCart) {
    const dataCart = await addToCartFunction(
      id,
      quantity,
      undefined,
      shippingMethod
    );
    shopifyProductsCartItems = dataCart.items;

    let itemSelected_ = null;
    dataCart.items.forEach(element => {
      if (parseInt(element.id) === parseInt(id)) {
        itemSelected_ = element;
      }
    });

    if (itemSelected_) {
      addPopUpInformation(itemSelected_);
      addMinicartInformation();
    }
  } else {
    const button = form.querySelector(".add-cart-button");

    functionAnimation(button);
  }
};

const listenAddCart = () => {
  const addForm = document.querySelector("#pdp_form");

  if (addForm != null) {
    addForm.addEventListener("submit", (e) => {
      e.preventDefault();

      sendDataForm(addForm);

      pdpEventsClick(
        "agregar_al_carrito",
        localStorage.getItem("selectedMethod"),
        "",
        JSON.parse(addForm.querySelector('[name="current_variant"]').value)[0]
          .name,
        JSON.parse(addForm.querySelector('[name="current_variant"]').value)[0]
      );
    });
  }
};

listenAddCart();
